module.exports = __webpack_public_path__ + "img/lm.03a8db77.png";